<template>
  <div :class="{'nav-open': $sidebar.showSidebar}">
    <notifications transition-name="notification-list" transition-mode="out-in"></notifications>
    <router-view name="header"></router-view>
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
    <router-view name="footer"></router-view>
    <notifications></notifications>
  </div>
</template>

<script>
// Loading some plugin css asynchronously
import "sweetalert2/dist/sweetalert2.css";
import "vue-notifyjs/themes/default.css";
export default {
  methods: {
  },

  beforeCreate() {

        
  },
  mounted() {
     // window.Intercom("boot", {
        //  app_id: "epbdrack",
       //  name: this.$store.getters['currentUser/getCurrentUsersFullName'],
        //  email: this.$store.getters['currentUser/getCurrentUsersLogin'],
       //   role: this.$store.getters['currentUser/getCurrentUsersRole'],
        //  practice: this.$store.getters['currentUser/getCurrentUsersPractice']
     // });
     LiveChatWidget.call("set_customer_name", this.$store.getters['currentUser/getCurrentUsersFullName']);
     LiveChatWidget.call("set_customer_email", this.$store.getters['currentUser/getCurrentUsersLogin']);

    }
};
</script>
<style lang="scss">
</style>
